import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import HazardDetail from './HazardDetail';

/**
 * Canonical incident detail route (/incidents/:id).
 *
 * The backend split (split_incidents_from_hazards.py) preserves UUIDs, so an
 * incident's id also exists in the legacy hazards table during Phase 2 soak.
 * This page reuses HazardDetail so every sub-feature (photos, documents,
 * RCA, 8D, statutory reports, CAPA linking) keeps working with no regression
 * while /incidents becomes the canonical URL surface.
 *
 * Follow-up (tracked separately): HazardDetail should be parameterised with
 * an entityType prop so that its internal axios calls dispatch to
 * /incidents/* for incidents and /hazards/* for true hazards. Until that is
 * done, HazardDetail still queries /hazards/*, which works because the
 * hazards table retains the same UUIDs until the Phase 4 cleanup migration.
 */
const IncidentDetail = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Keep the canonical /incidents/:id URL in the address bar but render
  // HazardDetail so features continue to work. When HazardDetail is
  // parameterised, replace this passthrough with <HazardDetail entityType="incident" />.
  useEffect(() => {
    if (!id) {
      navigate('/incidents', { replace: true });
    }
  }, [id, navigate]);

  return <HazardDetail {...props} />;
};

export default IncidentDetail;
